import React from 'react';
import { useNavigate } from 'react-router-dom';
import './BottomSheetMenu.css';

interface BottomSheetMenuProps {
  isOpen: boolean;
  onClose: () => void;
  isLoggedIn: boolean;
  uid: string | null;
  onLogout: () => void;
  onLoginClick: () => void;
  onShowHistory: () => void;
  onShowChangePassword?: () => void;
}

const BottomSheetMenu: React.FC<BottomSheetMenuProps> = ({
  isOpen,
  onClose,
  isLoggedIn,
  onLogout,
  onLoginClick,
  onShowHistory,
  onShowChangePassword,
}) => {
  const navigate = useNavigate();
  const contentRef = React.useRef<HTMLDivElement | null>(null);

  if (!isOpen) return null;

  return (
    <div className="menu-container">
      <div className="menu-overlay" onClick={onClose} />

      <div
        className="menu-content"
        role="dialog"
        aria-modal="true"
        ref={contentRef}
      >
        <div className="menu-handle" />

        <div className="menu-list">
          <button
            className="menu-row"
            onClick={() => {
              navigate('/trang-chu');
              onClose();
            }}
          >
            Trang chủ
          </button>

          <button
            className="menu-row"
            onClick={() => {
              navigate('/quy-dinh');
              onClose();
            }}
          >
            Quy định
          </button>

          <hr />

          <button
            className="menu-row"
            onClick={() => {
              if (isLoggedIn) {
                onLogout();
                onClose();
              } else {
                onLoginClick();
                onClose();
              }
            }}
          >
            {isLoggedIn ? 'Đăng xuất' : 'Đăng nhập'}
          </button>

          {isLoggedIn && (
            <button
              className="menu-row"
              onClick={() => {
                if (onShowChangePassword) {
                  onShowChangePassword();
                }
                onClose();
              }}
            >
              Đổi mật khẩu
            </button>
          )}

          {isLoggedIn && (
            <button
              className="menu-row"
              onClick={() => {
                try {
                  onShowHistory();
                } catch (e) {
                  navigate('/history');
                }
                onClose();
              }}
            >
              Đơn hàng
            </button>
          )}

          <div style={{ height: 40 }} />
        </div>
      </div>
    </div>
  );
};

export default BottomSheetMenu;
